module.exports = __webpack_public_path__ + "static/media/rating-star-epty-icon.a5180766.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-eireann/rating-star-epty-icon.svg
// module id = 649
// module chunks = 0